<template lang="pug">
  v-dialog(v-model='dialog2' scrollable persistent max-width='80%')
      v-card
        v-card-title
          span.headline {{ formTitle }}
        v-card-text
          v-container
            v-row
              v-col(cols='12' sm='12' md='12')
                v-autocomplete(autocomplete="off" dense label="Cuenta Por Cobrar" outlined v-model='form.idCuentaPorCobrar' :items="idCXCArray")
        v-card-actions
          v-spacer
          v-btn(color='success' small dark @click='save')
            v-icon 
            | Actualizar
          v-btn(color='error' small dark @click='close')
            v-icon mdi-close
            | Cancelar
</template> 
<script>
import Api from '@/services/methods'
export default {
  props: ['dialog2', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    ban: false,
    search: '',
    cxc: [],
    idCXCArray: [],
    date: new Date().toISOString().substr(0, 10),
    form: {
      idCuentaPorCobrar: '',
      idConcepto: '',
      idBanco: '',
      idTipoPago: '',
      idVenta: '',
      monto: 0,
      descripcion: '',
      referencia: '',
      numeroCheque: '',
      fechaRegistro: '',
      fechaCobro: '',
      fecha: '',
      confirmacion: false
    },
    defaultItem: {
      idCuentaPorCobrar: '',
      idConcepto: '',
      idBanco: '',
      idTipoPago: '',
      idVenta: '',
      monto: 0,
      descripcion: '',
      referencia: '',
      numeroCheque: '',
      fechaRegistro: '',
      fechaCobro: '',
      fecha: '',
      confirmacion: false
    },
  }),

  computed: {
    formTitle () {
      return 'Actualizar ID Cuenta por Cobrar'
    }
  },

  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarCuentasXCobrar()
    },

    listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          this.loading = false
          this.cxc.map(data => {
            this.idCXCArray.push({
              text: data.numFactura,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        // this.form.descripcion = ''
      }, 300)
      this.$emit('close')
    },

    save () {
      this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
      Api.put('pago/idcxc', this.form)
        .then(response => {
          this.$emit('edited')
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
        })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
               text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      this.close()
    }
  }
}
</script>
